module.exports = __webpack_public_path__ + "media/images/login/login_bg-dc5f0101e0d66bb0eee2862a5cbbf0bb.jpg";